export default __webpack_public_path__ + "static/media/google_frbe.37d3ddf2.png";